import {
  ModalCampaignSuccess,
  InfoContainer,
  ContentContainer,
  ButtonsContainer,
  ConfirmButton,
  CloseButton,
  MainInfo,
  ComplementaryInfo
} from './campaignSuccess.styles';

export default function ConfirmCampaignModal({ showModal, onClose, onConfirm, campaignData }) {
  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const efisysCredit = {
    clientId: 'ddfeaf76-c79a-44a0-94b1-ec9b5ccaa4d7', //id del usuario
    typeOperation: 'NR',
    creditRequestNumber: '0',
    customerNumber: '52',
    currencyNumber: '1',
    numCreditProduct: '2000',
    prospectNumber: 'ddfeaf76-c79a-44a0-94b1-ec9b5ccaa4d7', //id del usuario
    creditType: 'N',
    registrationDate: campaignData.dateStartCampaign, // fecha que se registra la campaña
    amountRequested: campaignData.montoSolicitado, // cantidad solicitada para la campaña
    termNumber: campaignData.plazoCredito, // numero de dias que requiere para pagar el prestamo de la campaña
    typeDispersion: 'S', //Tiene que ser SPEI = "S"
    keyAccount: '', //CLABE del applicant
    branchOfficeNumber: '001',
    openCommMet: 'D',
    amountCommOpen: campaignData.interesCreditoPesos, //la multiplicacion del monto por 360, esto hay que sacarlo de lo que se calcula de la campaña que es el interest del total
    commOpenVat: campaignData.IVAcomisionCreditoPesos, //no recuerdo si tenemos IVA por comision, pero hay que checar algo que se multiplique por .16
    creditDestinationNumber: '30001',
    promoterNumber: '1',
    interCalcNumber: campaignData.tasaCreditoPorcentaje, // la TIIE mas su calificación
    fixedRate: campaignData.tasaCreditoPorcentaje, // no se si es lo de arriba o lo de solo el 18% anual
    baseRate: '0.0000',
    aboutRate: '0.0000',
    floorRate: '0.0000',
    ceilingRate: '0.0000',
    moraFactor: campaignData.tasaInteresMoratorioPorcentaje, // ya lo traemos en campaña es lo de la moratoria
    capFrequency: 'U',
    capPeriod: '1', // segun debe de ser 1, porque es pago unico
    frequencyInter: 'U',
    interPeriod: campaignData.plazoCredito, //esto es para los intereses, es numero de dias debe de ser el termLoan
    typeCapPay: 'I',
    numAmorti: '1',
    irregularCalendar: 'N',
    interPayDay: campaignData.plazoCredito, // es el numero de dias del term loan (dia en que se pagaran interes)
    capiPayDay: campaignData.plazoCredito, // es el numero de dias del term loan (dia en que se pagaran capital)
    capPayDayProd: 'I',
    dayMonthInter: campaignData.dateEndCampaign, // hacer split para solo tener día
    dayMonthCap: campaignData.dateEndCampaign, // hacer split para solo tener día
    ajsuteLastDateAmor: 'N',
    adjustDueDateMatu: 'N',
    transactionNumberSim: '0',
    valueCat: campaignData.tasaCreditoPorcentaje, //formula TIE 20% + 18% com anual
    disabledDay: 'S',
    customerInput: '0.00',
    liquidGuaranPerce: '0.00',
    creditNum: '0',
    classifiCreditDesti: campaignData.destinoCredito, //
    related: '0',
    project: campaignData.destinoCredito,
    typeFunding: 'F',
    interCalcType: '2',
    iterAmorNum: '1', //hardcode
    feeAmount: '500.00', //hardcode
    duedate: campaignData.dateEndCampaign, //fecha vencimiento crédito en día hábil
    executiveComment: ' --> 2020-05-04 14:22:12 - EFISYS2 -----',
    startDate: campaignData.dateStartCampaign, // fecha que se registra la campaña
    startDateAmor: campaignData.dateStartCampaign // fecha que se registra la campaña
  };
  //Efisys credit-request

  return (
    <ModalCampaignSuccess showModalCampaignSuccess={showModal}>
      <ContentContainer>
        <h2>
          ¡Estás apunto de crear una campaña con <span>FINSPHERA!</span>
        </h2>
        <InfoContainer>
          <MainInfo>
            <h3>Nombre de campaña:</h3>
            <p> {campaignData.nombreCampania} </p>
            <h3>Monto del crédito:</h3>
            <p>{formatCurrency(campaignData.montoSolicitado)}</p>
            <h3>Plazo en días:</h3>
            <p>{campaignData.plazoCredito}</p>
            <h3>Destino del crédito:</h3>
            <p>{campaignData.destinoCredito}</p>
            <h3>Fecha de publicación:</h3>
            <p>{formatDate(campaignData.dateStartCampaign)}</p>
            <h3>Fin de campaña:</h3>
            <p>{formatDate(campaignData.dateEndCampaign)}</p>
          </MainInfo>
          <ComplementaryInfo>
            <table>
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Tasa de interés adicional</td>
                  <td>{campaignData.tasaInteresAdicionalPorcentaje * 100} %</td>
                </tr>
                <tr>
                  <td>Tasa de interés del crédito</td>
                  <td>{Number(campaignData.tasaCreditoPorcentaje * 100).toFixed(2)} %</td>
                </tr>
                <tr>
                  <td>Interes del crédito en pesos</td>
                  <td>{formatCurrency(campaignData.interesCreditoPesos)}</td>
                </tr>
                <tr>
                  <td>IVA del interes del crédito en pesos</td>
                  <td>{formatCurrency(campaignData.IVAinteresCreditoPesos)}</td>
                </tr>
                <tr>
                  <td>Interes del crédito en pesos + IVA</td>
                  <td>{formatCurrency(campaignData.interesesCreditoPesosConIVA)}</td>
                </tr>
                <tr>
                  <td>Comisión del crédito</td>
                  <td>{formatCurrency(campaignData.comisionCreditoPesos)}</td>
                </tr>
                <tr>
                  <td>IVA de la comisión del crédito</td>
                  <td>{formatCurrency(campaignData.IVAcomisionCreditoPesos)}</td>
                </tr>
                <tr>
                  <td>Comisión del crédito + IVA</td>
                  <td>{formatCurrency(campaignData.comisionCreditoPesosConIVA)}</td>
                </tr>
                <tr>
                  <td>Monto de inversión de Finsphera en la campaña</td>
                  <td>{formatCurrency(campaignData.inversionFinspheraCampaniaPesos)}</td>
                </tr>
              </tbody>
            </table>
          </ComplementaryInfo>
          {/* <ComplementaryInfo>
            <p>Tasa de interés adicional: {campaignData.tasaInteresAdicionalPorcentaje} % </p>
            <p>
              Tasa de interés del crédito: {Number(campaignData.tasaCreditoPorcentaje).toFixed(2)} %
            </p>
            <p>Interes del crédito en pesos: {formatCurrency(campaignData.interesCreditoPesos)}</p>
            <p>
              IVA del interes del crédito en pesos:{' '}
              {formatCurrency(campaignData.IVAinteresCreditoPesos)}
            </p>
            <p>
              Interes del crédito en pesos + IVA:{' '}
              {formatCurrency(campaignData.interesesCreditoPesosConIVA)}
            </p>
            <p>Comisión del crédito: {formatCurrency(campaignData.comisionCreditoPesos)}</p>
            <p>
              IVA de la comisión del crédito: {formatCurrency(campaignData.IVAcomisionCreditoPesos)}
            </p>
            <p>
              Comisión del crédito + IVA: {formatCurrency(campaignData.comisionCreditoPesosConIVA)}
            </p>
            <p>
              Monto de inversión de Finsphera en la campaña:{' '}
              {formatCurrency(campaignData.inversionFinspheraCampaniaPesos)}
            </p>
          </ComplementaryInfo> */}
        </InfoContainer>
        <ButtonsContainer>
          <CloseButton onClick={onClose}>Cancelar</CloseButton>
          <ConfirmButton onClick={onConfirm}>Crear</ConfirmButton>
        </ButtonsContainer>
      </ContentContainer>
    </ModalCampaignSuccess>
  );
}
